/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferralType } from './ReferralType';
import {
    ReferralTypeFromJSON,
    ReferralTypeFromJSONTyped,
    ReferralTypeToJSON,
    ReferralTypeToJSONTyped,
} from './ReferralType';
import type { Recipient } from './Recipient';
import {
    RecipientFromJSON,
    RecipientFromJSONTyped,
    RecipientToJSON,
    RecipientToJSONTyped,
} from './Recipient';

/**
 * 
 * @export
 * @interface OutboundReferralItem
 */
export interface OutboundReferralItem {
    /**
     * 
     * @type {string}
     * @memberof OutboundReferralItem
     */
    referral_id: string;
    /**
     * 
     * @type {string}
     * @memberof OutboundReferralItem
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof OutboundReferralItem
     */
    sender_facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof OutboundReferralItem
     */
    sender_organization_id: string;
    /**
     * 
     * @type {Date}
     * @memberof OutboundReferralItem
     */
    target_discharge_date: Date;
    /**
     * 
     * @type {ReferralType}
     * @memberof OutboundReferralItem
     */
    referral_type: ReferralType;
    /**
     * 
     * @type {string}
     * @memberof OutboundReferralItem
     */
    status: OutboundReferralItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OutboundReferralItem
     */
    close_reason: OutboundReferralItemCloseReasonEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof OutboundReferralItem
     */
    sent_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof OutboundReferralItem
     */
    confirmed_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof OutboundReferralItem
     */
    closed_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof OutboundReferralItem
     */
    created_at: Date;
    /**
     * 
     * @type {string}
     * @memberof OutboundReferralItem
     */
    created_by_user_id: string;
    /**
     * 
     * @type {Date}
     * @memberof OutboundReferralItem
     */
    updated_at: Date;
    /**
     * 
     * @type {string}
     * @memberof OutboundReferralItem
     */
    updated_by_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof OutboundReferralItem
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof OutboundReferralItem
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof OutboundReferralItem
     */
    ssn: string;
    /**
     * 
     * @type {Date}
     * @memberof OutboundReferralItem
     */
    dob: Date;
    /**
     * 
     * @type {Date}
     * @memberof OutboundReferralItem
     */
    latest_activity_at?: Date;
    /**
     * 
     * @type {Array<Recipient>}
     * @memberof OutboundReferralItem
     */
    recipients: Array<Recipient>;
    /**
     * True when ANY recipient thread on this referral has an inbound message newer than the caller's per-thread read receipt. Computed per-thread; a read receipt on one thread does not clear the indicator for other threads.
     * @type {boolean}
     * @memberof OutboundReferralItem
     */
    has_unread: boolean;
}


/**
 * @export
 */
export const OutboundReferralItemStatusEnum = {
    Draft: 'draft',
    Sent: 'sent',
    Confirmed: 'confirmed',
    Closed: 'closed'
} as const;
export type OutboundReferralItemStatusEnum = typeof OutboundReferralItemStatusEnum[keyof typeof OutboundReferralItemStatusEnum];

/**
 * @export
 */
export const OutboundReferralItemCloseReasonEnum = {
    ConfirmedElsewhere: 'confirmed_elsewhere',
    Declined: 'declined',
    Lost: 'lost',
    Withdrawn: 'withdrawn'
} as const;
export type OutboundReferralItemCloseReasonEnum = typeof OutboundReferralItemCloseReasonEnum[keyof typeof OutboundReferralItemCloseReasonEnum];


/**
 * Check if a given object implements the OutboundReferralItem interface.
 */
export function instanceOfOutboundReferralItem(value: object): value is OutboundReferralItem {
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('sender_facility_id' in value) || value['sender_facility_id'] === undefined) return false;
    if (!('sender_organization_id' in value) || value['sender_organization_id'] === undefined) return false;
    if (!('target_discharge_date' in value) || value['target_discharge_date'] === undefined) return false;
    if (!('referral_type' in value) || value['referral_type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('close_reason' in value) || value['close_reason'] === undefined) return false;
    if (!('sent_at' in value) || value['sent_at'] === undefined) return false;
    if (!('confirmed_at' in value) || value['confirmed_at'] === undefined) return false;
    if (!('closed_at' in value) || value['closed_at'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('created_by_user_id' in value) || value['created_by_user_id'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    if (!('updated_by_user_id' in value) || value['updated_by_user_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('ssn' in value) || value['ssn'] === undefined) return false;
    if (!('dob' in value) || value['dob'] === undefined) return false;
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    if (!('has_unread' in value) || value['has_unread'] === undefined) return false;
    return true;
}

export function OutboundReferralItemFromJSON(json: any): OutboundReferralItem {
    return OutboundReferralItemFromJSONTyped(json, false);
}

export function OutboundReferralItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundReferralItem {
    if (json == null) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
        'lead_id': json['lead_id'],
        'sender_facility_id': json['sender_facility_id'],
        'sender_organization_id': json['sender_organization_id'],
        'target_discharge_date': (new Date(json['target_discharge_date'])),
        'referral_type': ReferralTypeFromJSON(json['referral_type']),
        'status': json['status'],
        'close_reason': json['close_reason'],
        'sent_at': (new Date(json['sent_at'])),
        'confirmed_at': (new Date(json['confirmed_at'])),
        'closed_at': (new Date(json['closed_at'])),
        'created_at': (new Date(json['created_at'])),
        'created_by_user_id': json['created_by_user_id'],
        'updated_at': (new Date(json['updated_at'])),
        'updated_by_user_id': json['updated_by_user_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'ssn': json['ssn'],
        'dob': (new Date(json['dob'])),
        'latest_activity_at': json['latest_activity_at'] == null ? undefined : (new Date(json['latest_activity_at'])),
        'recipients': ((json['recipients'] as Array<any>).map(RecipientFromJSON)),
        'has_unread': json['has_unread'],
    };
}

export function OutboundReferralItemToJSON(json: any): OutboundReferralItem {
    return OutboundReferralItemToJSONTyped(json, false);
}

export function OutboundReferralItemToJSONTyped(value?: OutboundReferralItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referral_id': value['referral_id'],
        'lead_id': value['lead_id'],
        'sender_facility_id': value['sender_facility_id'],
        'sender_organization_id': value['sender_organization_id'],
        'target_discharge_date': ((value['target_discharge_date']).toISOString().substring(0,10)),
        'referral_type': ReferralTypeToJSON(value['referral_type']),
        'status': value['status'],
        'close_reason': value['close_reason'],
        'sent_at': ((value['sent_at']).toISOString()),
        'confirmed_at': ((value['confirmed_at']).toISOString()),
        'closed_at': ((value['closed_at']).toISOString()),
        'created_at': ((value['created_at']).toISOString()),
        'created_by_user_id': value['created_by_user_id'],
        'updated_at': ((value['updated_at']).toISOString()),
        'updated_by_user_id': value['updated_by_user_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'ssn': value['ssn'],
        'dob': ((value['dob']).toISOString().substring(0,10)),
        'latest_activity_at': value['latest_activity_at'] == null ? undefined : ((value['latest_activity_at']).toISOString()),
        'recipients': ((value['recipients'] as Array<any>).map(RecipientToJSON)),
        'has_unread': value['has_unread'],
    };
}

